import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeResignationRequest  {
    _originalTypeClassName = "zERP.BO.EmployeeResignationRequest";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeResignationRequest.translate = translateService;
}
this.Actions = [];
this.Id = null;
this.DateResignation = null;
this.EmployeeNotes = null;
this.HRNotes = null;
this.FlowStepIndex = 0;
this.DateRequested = null;
this.ManagerStatus = null;
this.ManagerDateApproved = null;
this.HRStatus = null;
this.HRDateApproved = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateResignation:any;
EmployeeNotes:any;
HRNotes:any;
FlowStepIndex:any;
DateRequested:any;
ManagerStatus:any;
ManagerDateApproved:any;
HRStatus:any;
HRDateApproved:any;
RequestedBy:any;
ActiveTask:any;
ApprovalFlowScenario:any;
Actions:any;
ManagerApprovedBy:any;
Employee:any;
ResignationRule:any;
EmployeeContract:any;
HRApprovedBy:any;
static setRequestedBy = ($this, value) => {
var oldValue = $this.RequestedBy;
$this.RequestedBy = value;
if (value != null) {
}
}
static setActiveTask = ($this, value) => {
var oldValue = $this.ActiveTask;
$this.ActiveTask = value;
if (value != null) {
}
}
static setApprovalFlowScenario = ($this, value) => {
var oldValue = $this.ApprovalFlowScenario;
$this.ApprovalFlowScenario = value;
if (value != null) {
}
}
static setActions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Actions == null) $this.Actions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Actions.length > 0) {
                    Domain.EmployeeResignationRequest.removeActions($this, $this.Actions[0]);
                }

                Domain.EmployeeResignationRequest.addManyActions($this, copyItems);
            }
static addManyActions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeResignationRequest.addActions($this, items[i]);
                }
            }
static addActions = ($this, item) => {
                if ($this.Actions == null) $this.Actions = [];
                if (item == null || $this.Actions.indexOf(item) > -1) return;
                $this.Actions.push(item);
if (item.ResignationRequest != $this) {
Domain.ResignationRequestAction.setResignationRequest(item, $this);
}
}
static addRangeActions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeResignationRequest.addActions($this, item));
            }
static removeActions = ($this, item) => {
                if ($this == null || $this.Actions == null || $this.Actions.indexOf(item) === -1) return;
                var _index = $this.Actions.indexOf(item);
                $this.Actions.splice(_index, 1);
item.ResignationRequest = null;
}
static clearActions = ($this) => { $this.Actions = null; }
static setManagerApprovedBy = ($this, value) => {
var oldValue = $this.ManagerApprovedBy;
$this.ManagerApprovedBy = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setResignationRule = ($this, value) => {
var oldValue = $this.ResignationRule;
$this.ResignationRule = value;
if (value != null) {
}
}
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}
static setHRApprovedBy = ($this, value) => {
var oldValue = $this.HRApprovedBy;
$this.HRApprovedBy = value;
if (value != null) {
}
}

static CheckStatusTransition(currentStatus: any,newStatus: any): any{if (newStatus == Domain.ResignationRequestStatus.Temporary) {return currentStatus == Domain.ResignationRequestStatus.Temporary;}else if (newStatus == Domain.ResignationRequestStatus.Pending) {return currentStatus == Domain.ResignationRequestStatus.Temporary;}else if (newStatus == Domain.ResignationRequestStatus.Approved) {return currentStatus == Domain.ResignationRequestStatus.Pending;}else if (newStatus == Domain.ResignationRequestStatus.Rejected) {return currentStatus == Domain.ResignationRequestStatus.Pending;}
return false;
}
static FillApprovalScenarion($this: any): any{if ($this?.ApprovalFlowScenario != null) {return;}
Domain.EmployeeResignationRequest.setApprovalFlowScenario($this, Domain.ApprovalFlow.GetScenario($this?.ResignationRule?.ApprovalFlow, $this?.EmployeeContract));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}